export default {
  es: {
    stage: 'Estadío',
    last: 'Último',
    previous: 'Anterior',
    high: 'Alto',
    normalLow: 'Normal o Bajo',
    bloodGlucose: {
      title: 'Control de mi diabetes mellitus',
      description:
        'El siguiente gráfico muestra sus últimos valores de hemoglobina glicosilada'
    },
    kidneyProgress: {
      title: 'Evolución de mi enfermedad renal',
      description:
        'Basada en el comportamiento de la tasa de filtración glomerular.',
      stable: 'Se mantiene estable',
      increased: 'Subió ',
      decreased: 'Disminuyó ',
      footerText: ' con relación al último registro de TFG.',
      changeStage: 'Cambia de',
      to: 'a',
      sameStage: 'Se mantiene en el mismo estadío.'
    },
    bloodPressure: {
      description1:
        'El siguiente gráfico muestra sus últimos valores de tensión arterial sistólica y diastólica registrados en consulta:'
    },
    myLabs: {
      title:
        'Aquí se muestran tus últimos valores de los siguientes laboratorios:',
      high: 'Alto',
      low: 'Bajo',
      critic: 'Crítico',
      applies: 'Cumple',
      notApplies: 'No cumple'
    },
    myRecommendations: {
      title:
        'Aquí puedes ver las recomendaciones y notas que tus médicos tratantes te han dejado luego de una visita.'
    }
  },
  en: {
    stage: 'Stage',
    last: 'Last',
    previous: 'Previous',
    high: 'High',
    normalLow: 'Normal or Low',
    bloodGlucose: {
      title: 'Blood glucose control',
      description:
        'Next chart shows your last values of glycosylated hemoglobin'
    },
    kidneyProgress: {
      title: 'Kidney progress',
      description: 'Based on gromerular filtration rate behavior',
      stable: 'It remains stable',
      increased: 'Increased ',
      decreased: 'Decreased ',
      footerText: ' related to the last (GFR) record.',
      changeStage: 'Change from',
      to: 'to',
      sameStage: 'It remains in the same stage.'
    },
    bloodPressure: {
      description1:
        'Next chart shows your last values of de systolic and diastolic blood pressure, registered in consultation:'
    },
    myLabs: {
      title: 'Your latest values ​​from the following labs are shown here:',
      high: 'High',
      low: 'Low',
      critic: 'Critic',
      applies: 'Applies',
      notApplies: `Doesn't Applies`
    },
    myRecommendations: {
      title:
        'Here you can see the recommendations and notes that your treating doctors have left you after a visit.'
    }
  }
};
